import {
  GET_SUBCONTRACTORS,
  GET_SUBCONTRACTOR,
  CREATE_SUBCONTRACTOR,
  UPDATE_SUBCONTRACTOR,
  DELETE_SUBCONTRACTOR
} from '../actions/subcontractorActions';

const initialState = {
  subcontractors: [],
  subcontractor: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const subcontractorReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBCONTRACTORS:
      return {
        ...state,
        subcontractors: action.payload.subcontractors,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };

    case GET_SUBCONTRACTOR:
      return {
        ...state,
        subcontractor: action.payload,
        isLoading: false
      };

    case CREATE_SUBCONTRACTOR:
      return {
        ...state,
        subcontractors: [action.payload, ...state.subcontractors]
      };

    case UPDATE_SUBCONTRACTOR:
      return {
        ...state,
        subcontractors: state.subcontractors.map(s =>
          s._id === action.payload._id ? action.payload : s
        ),
        subcontractor: action.payload
      };

    case DELETE_SUBCONTRACTOR:
      return {
        ...state,
        subcontractors: state.subcontractors.filter(s => s._id !== action.payload)
      };

    default:
      return state;
  }
};

export default subcontractorReducer;
